import { NgRedux } from '@ptl/angular-redux-store';
import { Injectable } from '@angular/core';
import { StateStructure } from '@ptl/state';
import { resetAuthRep } from '../../shared/reducers/authorized-representative.reducer';
import { resetEnrollment } from '../../shared/reducers/enrollment.reducer';
import { resetInsuranceInfo } from '../../shared/reducers/insuranceInfo.reducer';
import { resetMeds } from '../../shared/reducers/medigap-medications.reducer';
import { resetMedigapEligibilityCheck } from '../../shared/reducers/medigapEligibilityCheck.reducer';
import { resetPayment } from '../../shared/reducers/payment.reducer';
import { resetPersonalInfo, resetPersonalInfoControl } from '../../shared/reducers/personalInfo.reducer';
import { resetPreliminaryInfo } from '../../shared/reducers/preliminary.reducer';
import { resetStatementAuth } from '../../shared/reducers/statementAuth.reducer';
import { resetDirtyEffectiveDate } from './components/configs/reducers/effective-date.reducer';
import { resetSEPLifeEventDocumentInfo } from './components/configs/reducers/life-event.reducer';

@Injectable({
  providedIn: 'root'
})
export class ReducerResetService {

  constructor(
    private ngRedux: NgRedux<StateStructure>
  ) { }

  resetComponentStates(){}

  resetAppStates(){
    this.ngRedux.dispatch(resetDirtyEffectiveDate());
  }

  resetPayloadStates(){
    this.ngRedux.dispatch(resetMeds());
    this.ngRedux.dispatch(resetEnrollment());
    this.ngRedux.dispatch(resetPersonalInfo());
    this.ngRedux.dispatch(resetInsuranceInfo());
    this.ngRedux.dispatch(resetStatementAuth());
    this.ngRedux.dispatch(resetPayment());
    this.ngRedux.dispatch(resetMedigapEligibilityCheck());
    this.ngRedux.dispatch(resetPreliminaryInfo());
    this.ngRedux.dispatch(resetAuthRep());
    this.ngRedux.dispatch(resetSEPLifeEventDocumentInfo());
  }
  
}
